export interface Lead {
  id: number;
  businessid: number;
  name: string;
  company: string;
  email: string;
  phone: string;
  state: LeadState;
  lastContact: Date;
  value: number | string;
  notes: string;
  leadSource: string;
  dueDate?: Date;
  probability?: number;
  status?: StatusOption;
  assignedCommercialistaId?: string;
  customFields?: Record<string, any>;
  vendor_id?: string;
  vendor_name?: string;
  vendor_pic?: string;
}

export interface StatusOption {
  id: string;
  label: string;
  color: string;
}

export enum LeadState {
  New = "Nuova lead",
  Qualified = "Persa",
  Appuntamento = "Appuntamento",
  Proposal = "Trattativa",
  Negotiation = "Non interessato",
  Won = "Contratto",
}

export const DefaultLead: Lead = {
  id: 0,
  businessid: 0,
  name: "",
  company: "",
  email: "",
  phone: "",
  state: LeadState.New,
  lastContact: new Date(),
  value: "",
  notes: "",
  leadSource: "",
};
